import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";

import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateVehicleVehicleOperationsScreen,
  createVehicleVehicleOperations,
  editVehicleVehicleOperations,
  fetchVehicleVehicleOperationsById,
  uploadImage,
} from "../../../../redux/actions/vehicles/vehicleVehicleOperations";
import {
  fetchVehicleMakeDD
} from "../../../../redux/actions/vehicles/vehicleMake";
import {
  fetchVehicleModelDD
} from "../../../../redux/actions/vehicles/vehicleModel";
import {
  fetchVehicleTrimDD
} from "../../../../redux/actions/vehicles/vehicleTrim";
import {
  fetchVehicleStatusDD
} from "../../../../redux/actions/vehicles/vehicleVehicleStatus";
import {
  fetchVehicleDealershipsDD
} from "../../../../redux/actions/vehicles/vehicleDealerships";
import {
  fetchVehicleCategoryDD
} from "../../../../redux/actions/vehicles/vehicleCategory";
import {
  fetchLocationDD
} from "../../../../redux/actions/location";
import { useEffect } from "react";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import CreateVehicleVehicleOperationsComponent from "../../../../component/Vehicles/VehicleVehicleOperations/CreateVehicleVehicleOperations";
import { useParams } from "react-router-dom";

const CreateVehicleVehicleOperationsContainer = (props) => {
  console.log("checkprops on screen ", props);
  const {
    history,
    createVehicleVehicleOperations,
    editVehicleVehicleOperations,
    isLoading,
    isVehicleVehicleOperationsCreateSuccess,
    isVehicleVehicleOperationsCreateError,
    isVehicleVehicleOperationsDetailSuccess,
    isVehicleVehicleOperationsDetailError,
    isVehicleVehicleOperationsEditSuccess,
    isVehicleVehicleOperationsEditError,
    isEdit,
    isView,
    initCreateVehicleVehicleOperationsScreen,
    formFieldValueMap,
    fetchVehicleVehicleOperationsById,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    shouldBlockNavigation,
    fetchVehicleMakeDD,
    fetchVehicleModelDD,
    fetchVehicleTrimDD,
    fetchVehicleStatusDD,
    fetchVehicleDealershipsDD,
    fetchVehicleCategoryDD,
    fetchLocationDD,
    locationDD,
    vehicleMakeDD,
    vehicleModelDD,
    vehicleTrimDD,
    vehicleStatusDD,
    vehicleDealershipsDD,
    vehicleCategoryDD,
        isVehicleOperationDDSuccess,
        isVehicleOperationDDError,
  } = props;

  const { id } = useParams();
  const callAPIasync = async() =>{
    initCreateVehicleVehicleOperationsScreen();
    await fetchVehicleTrimDD();
    await fetchVehicleMakeDD();
    await fetchVehicleModelDD();
    await fetchVehicleDealershipsDD();
    await fetchVehicleStatusDD();
    await fetchVehicleCategoryDD();
    await fetchLocationDD();
   if (isEdit) {
    await fetchVehicleVehicleOperationsById({id:id});
  }
  }
  useEffect(() => {
    callAPIasync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  useEffect(() => {
    if (isVehicleVehicleOperationsCreateSuccess || isVehicleVehicleOperationsEditSuccess) {
      shouldBlockNavigation(false);
    }
  }, [isVehicleVehicleOperationsCreateSuccess, isVehicleVehicleOperationsEditSuccess, shouldBlockNavigation]);

  const createVehicleVehicleOperationsProps = {
    createVehicleVehicleOperations,
    initCreateVehicleVehicleOperationsScreen,
    editVehicleVehicleOperations,
    isLoading,
    isEdit,
    isVehicleVehicleOperationsDetailSuccess,
    isVehicleVehicleOperationsCreateSuccess,
    isVehicleVehicleOperationsEditSuccess,
    isVehicleVehicleOperationsEditError,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleMakeDD,
    vehicleModelDD,
    vehicleTrimDD,
    vehicleStatusDD,
    vehicleDealershipsDD,
    vehicleCategoryDD,
    locationDD,
        isVehicleOperationDDSuccess,
        isVehicleOperationDDError,
  };
  const getToastProps = () => {
    if (isVehicleVehicleOperationsCreateSuccess || isVehicleVehicleOperationsEditSuccess) {
      const toastTitle = isEdit
        ? "VehicleVehicleOperations Updated Successfully"
        : "VehicleVehicleOperations Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isVehicleVehicleOperationsCreateError ||
      isVehicleVehicleOperationsDetailError ||
      isVehicleVehicleOperationsEditError
    ) {
      let toastTitle = "Error while Creating Vehicle VehicleOperations";
      if (isVehicleVehicleOperationsEditError) {
        toastTitle = "Error while updating Vehicle VehicleOperations";
      } else if (isVehicleVehicleOperationsDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateVehicleVehicleOperationsComponent {...createVehicleVehicleOperationsProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  console.log("mapState", state);
  return {
    isLoading: selectFromVehicleVehicleOperationsReducer(state, "isLoading"),
   
    isVehicleVehicleOperationsCreateSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsCreateSuccess"
    ),
    isVehicleVehicleOperationsCreateError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsCreateError"
    ),
    isVehicleVehicleOperationsDetailSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsDetailSuccess"
    ),
    isVehicleVehicleOperationsDetailError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsDetailError"
    ),
    isVehicleVehicleOperationsEditSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsEditSuccess"
    ),
    isVehicleVehicleOperationsEditError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleVehicleOperationsEditError"
    ),
    imageUploadResponse: selectFromVehicleVehicleOperationsReducer(
      state,
      "imageUploadResponse"
    ),
    isUploadImageSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isUploadImageSuccess"
    ),
    isUploadImageError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isUploadImageError"
    ),
    vehicleModelDD: selectFromVehicleVehicleModelReducer(
      state,
      "vehicleModelDD"
    ),
    vehicleTrimDD: selectFromVehicleVehicleTrimReducer(
      state,
      "vehicleTrimDD"
    ),
    
    vehicleMakeDD: selectFromVehicleVehicleMakeReducer(
      state,
      "vehicleMakeDD"
    ),

    vehicleOperationDD: selectFromVehicleVehicleOperationsReducer(
      state,
      "vehicleOperationDD"
    ),
    vehicleStatusDD: selectFromVehicleVehicleStatusReducer(
      state,
      "vehicleStatusDD"
    ),
    vehicleDealershipsDD: selectFromVehicleVehicleDealershipsReducer(
      state,
      "vehicleDealershipsDD"
    ),
    vehicleCategoryDD: selectFromVehicleVehicleCategoryReducer(
      state,
      "vehicleCategoryDD"
    ),
    locationDD: selectFromLocationReducer(
      state,
      "locationDD"
    ),
    isVehicleOperationDDSuccess: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleOperationDDSuccess"
    ),
    isVehicleOperationDDError: selectFromVehicleVehicleOperationsReducer(
      state,
      "isVehicleOperationDDError"
    ),

    formFieldValueMap: selectFromVehicleVehicleOperationsReducer(state, "formFieldValueMap"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateVehicleVehicleOperationsScreen: () => dispatch(initCreateVehicleVehicleOperationsScreen()),
    createVehicleVehicleOperations: (payload) => dispatch(createVehicleVehicleOperations(payload)),
    editVehicleVehicleOperations: (payload) => dispatch(editVehicleVehicleOperations(payload)),
    shouldBlockNavigation: (isFormDirty) =>dispatch(setIsformDirty(isFormDirty)),
    uploadImage:(payload) => dispatch(uploadImage(payload)),
    fetchVehicleVehicleOperationsById: (payload) => dispatch(fetchVehicleVehicleOperationsById(payload)),
    fetchVehicleMakeDD: (payload) => dispatch(fetchVehicleMakeDD(payload)),
    fetchVehicleModelDD: (payload) => dispatch(fetchVehicleModelDD(payload)),
    fetchVehicleTrimDD: (payload) => dispatch(fetchVehicleTrimDD(payload)),
    fetchVehicleStatusDD: (payload) => dispatch(fetchVehicleStatusDD(payload)),
    fetchVehicleDealershipsDD: (payload) => dispatch(fetchVehicleDealershipsDD(payload)),
    fetchVehicleCategoryDD: (payload) => dispatch(fetchVehicleCategoryDD(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
  };
};

const selectFromVehicleVehicleOperationsReducer = (state, path) => {
  return selectVehicleVehicleOperationsReducer(state)[path];
};

const selectVehicleVehicleOperationsReducer = ({ vehicleVehicleOperationsReducer }) => {
  return vehicleVehicleOperationsReducer;
};

//MAKE
const selectFromVehicleVehicleMakeReducer = (state, path) => {
  return selectVehicleVehicleMakeReducer(state)[path];
};
const selectVehicleVehicleMakeReducer = ({ vehicleMakeReducer }) => {
  return vehicleMakeReducer;
};
//Model
const selectFromVehicleVehicleModelReducer = (state, path) => {
  return selectVehicleVehicleModelReducer(state)[path];
};
const selectVehicleVehicleModelReducer = ({ vehicleModelReducer }) => {
  return vehicleModelReducer;
};
//Trim
const selectFromVehicleVehicleTrimReducer = (state, path) => {
  return selectVehicleVehicleTrimReducer(state)[path];
};
const selectVehicleVehicleTrimReducer = ({ vehicleTrimReducer }) => {
  return vehicleTrimReducer;
};
//Status
const selectFromVehicleVehicleStatusReducer = (state, path) => {
  return selectVehicleVehicleStatusReducer(state)[path];
};
const selectVehicleVehicleStatusReducer = ({ vehicleVehicleStatusReducer }) => {
  return vehicleVehicleStatusReducer;
};
//Dealerships
const selectFromVehicleVehicleDealershipsReducer = (state, path) => {
  return selectVehicleVehicleDealershipsReducer(state)[path];
};
const selectVehicleVehicleDealershipsReducer = ({ vehicleDealershipsReducer }) => {
  return vehicleDealershipsReducer;
};

//Category
const selectFromVehicleVehicleCategoryReducer = (state, path) => {
  return selectVehicleVehicleCategoryReducer(state)[path];
};
const selectVehicleVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};
//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateVehicleVehicleOperationsContainer);
